<template>
  <div class="send-egift-panel-deposit-info">
    <deposit-info-item
      v-for="(item, index) in items"
      :key="index"
      :content="item.content"
      :title="item.title"
      :videoUrl="item.videoUrl"
      :expandable="index !== 0"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import DepositInfoItem from '../components/DepositInfoItem.vue'

interface IInfoItem {
  title?: string,
  content: string,
  videoUrl?: string | null,
}

@Component({
  components: {
    DepositInfoItem,
  },
})
export default class SendEgiftPanelDepositInfo extends Vue {
  items: Array<IInfoItem> = [
    {
      videoUrl: 'https://www.youtube.com/embed/Gho6du8j-nM?rel=0',
      content: `We calculate your deposit estimate by multiplying the number of recipients by the
        highest-priced gift in the collection, including shipping, taxes, and a non-refundable
        service fee. After the transaction is finalized, we'll refund the difference between your
        deposit and the final cost of the chosen gifts. <br><br>
        <i>(Max gift cost + max sales tax rate + max shipping rate ) + non-refundable fee x number
        of recipients = Deposit</i>`,
    },
    {
      title: 'Max gift cost',
      videoUrl: null,
      content: `We calculate the maximum gift cost by multiplying the number of recipients by the
        highest-priced gift in the collection. <br><br>
        <i>Highest-priced gift in the collection x number of recipients = Max gift cost</i>`,
    },
    {
      title: 'Max shipping',
      videoUrl: null,
      content: `We calculate the maximum shipping cost by multiplying the number of recipients by
        the highest ground shipping rate. <br><br>
        <i>Highest ground shipping rate x number of recipients = Max shipping cost</i>`,
    },
    {
      title: 'Max sales tax',
      videoUrl: null,
      content: `We calculate the maximum sales tax of the highest-priced gift multiplied by the
        number of recipients. <br><br>
        <i>(Highest-priced gift + max sales tax) x number of recipients = Max sales tax</i>`,
    },
    {
      title: 'eGift fee',
      videoUrl: null,
      content: `A non-refundable fee of 10% per recipient is added to your order to cover our
        service costs. CG Elite members don't pay eGift fees.
        <a href="https://corporategift.com/pricing/" target="_blank">View member pricing</a>`,
    },
    {
      title: 'Max import charges',
      videoUrl: null,
      content: `Gifts shipped outside the United States can be subject to customs duty and import
        taxes (VAT). Because we don't know where your recipients live until they redeem, we estimate
        the highest possible charges for the destinations this gift can ship to. <br><br>
        You will only pay import charges for recipients who actually ship their gift abroad, and only
        for the value of the gifts they redeem — the difference is refunded with the rest of your
        deposit.`,
    },
  ]
}
</script>

<style lang="scss" scoped>
.send-egift-panel-deposit-info {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;

  &__info {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
}
</style>
